export const defineClientAppEnhance = (clientAppEnhance) => clientAppEnhance;
